import React, { useState } from 'react';
import BasicButton from '../Button/BasicButton';
import { useTranslation } from 'react-i18next';
import ModalWrapper from '../Modal/ModalWrapper';
import PaymentItemsWrapper from '../Payment/PaymentItemsWrapper';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { otpModalState } from '../../recoil/otp/otpModalAtom';
import { layoutTopState } from '../../recoil/layoutTop/layoutTopAtom';
import useGetBeatInfo from '../../hooks/useGetBeatInfo';
import ERROR_CODES from '../../constants/errorCodes';
import * as Sentry from '@sentry/react';
import { countryState } from '../../recoil/country/countryAtom';
import useCheckTokenExpiry from '../../hooks/useCheckTokenExpiry';

const ProductVideoInputWrapper = ({ productDetailData }) => {
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isBottomSheetShow, setIsBottomSheetShow] = useState(false);
  const setOtpLogin = useSetRecoilState(otpModalState);
  const setLayoutTop = useSetRecoilState(layoutTopState);
  const accessToken = localStorage.getItem('access_token');
  const countryData = useRecoilValue(countryState);
  const exp = localStorage.getItem('exp');

  // 단순 로그인 확인용
  const { error, isLogin, hasAccessToken } = useGetBeatInfo(accessToken, countryData?.country);
  const isAccessTokenExpired = useCheckTokenExpiry(exp);

  const { t } = useTranslation();

  const clearSession = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('exp');
    Sentry.setUser(null);
  };

  // 단순 로그인 확인용
  const handleLoginCheck = () => {
    const errorCode = error?.response && error?.response.data && error?.response.data.code;
    if (!hasAccessToken) {
      clearSession();
      setOtpLogin(true);
      return false;
    }

    if (isAccessTokenExpired) {
      clearSession();
      setOtpLogin(true);
      return false;
    }

    if (!isLogin) {
      clearSession();
      setOtpLogin(true);
      return false;
    }

    if (
      errorCode === ERROR_CODES.invalidToken ||
      errorCode === ERROR_CODES.tokenExpired ||
      errorCode === ERROR_CODES.unauthorized
    ) {
      clearSession();
      setOtpLogin(true);
      return false;
    }

    return true;
  };

  const openPurchaseModal = () => {
    if (handleLoginCheck()) {
      setIsPaymentModalOpen(true);
      setLayoutTop(true);
      // document.body.style.overflow = 'hidden';
    }
  };
  const closePurchaseModal = () => {
    setIsPaymentModalOpen(false);
    setLayoutTop(false);
    // document.body.style.overflow = 'auto';
  };

  const openBottomSheet = () => {
    if (handleLoginCheck()) {
      setIsBottomSheetShow(true);
    }
  };

  const closeBottomSheet = () => {
    setIsBottomSheetShow(false);
  };

  // sale_status - expected, on_sale, end_sale
  const getButtonTxt = () => {
    switch (productDetailData?.sale_status) {
      case 'on_sale':
        return t('purchase');
      case 'end_sale':
        return t('unavailable');
      default:
        return t('coming_soon');
    }
  };

  return (
    <>
      <div className={`bottom-sheet-all-wrapper ${isBottomSheetShow ? 'is-show' : ''}`}>
        {/* 모바일 노출 영역 */}
        <div className={'bottom-sheet-dim-overlay mb-show'} onClick={closeBottomSheet} />
        {/*  END 모바일 노출 영역 */}

        <div className={`bottom-sheet-content-all-wrapper ${isBottomSheetShow ? 'is-show' : ''}`}>
          {/* 모바일 노출 영역 */}
          <div className='mobiles-bottom-sheet-toggle-wrapper mb-show' onClick={closeBottomSheet}>
            <button className={'button-default bottom-sheet-toggle-button'} aria-label={'Close'} type={'button'} />
          </div>
          {/* END 모바일 노출 영역 */}

          {/* 모바일 노출 영역 */}
          <div className='selected-video-card-wrapper mb-show'>
            <p className={'selected-video-card-label'}>{t('select_products')}</p>
            <div className='selected-video-card'>
              <div className='selected-video-top-group'>
                <p className={'selected-video-title'}>{productDetailData?.title}</p>
              </div>
              <div className='selected-video-bottom-group'>
                <p className={'selected-video-card-price'}>
                  {productDetailData?.price?.toLocaleString()}
                  &nbsp;{productDetailData?.currency}
                </p>
              </div>
            </div>
          </div>
          {/* END 모바일 노출 영역 */}

          <div className={'product-bottom-sheet-wrapper'}>
            <div className='product-bottom-sheet-price-group'>
              <span className={'price-label'}>{t('total_price')}</span>
              <span className={'price-info'}>
                {productDetailData?.price?.toLocaleString()}
                &nbsp;{productDetailData?.currency}
              </span>
            </div>
            <div className={`product-bottom-sheet-button-group ${isPaymentModalOpen ? 'is-visibility-hidden' : ''}`}>
              <BasicButton
                buttonTxt={getButtonTxt()}
                buttonType={'primary'}
                disabled={
                  productDetailData?.sale_status === 'end_sale' ||
                  productDetailData?.sale_status === 'expected' ||
                  productDetailData?.purchased
                }
                onClick={openPurchaseModal}
              />
            </div>
          </div>
        </div>
      </div>

      {/* 모바일 노출 영역 */}
      <div className={'mobile-bottom-fixed-button-wrapper mb-show'}>
        <BasicButton
          buttonTxt={getButtonTxt()}
          buttonType={'primary'}
          disabled={
            productDetailData?.sale_status === 'end_sale' ||
            productDetailData?.sale_status === 'expected' ||
            productDetailData?.purchased
          }
          onClick={openBottomSheet}
        />
      </div>
      {/* END 모바일 노출 영역 */}

      <ModalWrapper
        isOpen={isPaymentModalOpen}
        isBottomButton={true}
        onClose={closePurchaseModal}
        mobileAlignTop={true}
      >
        {isPaymentModalOpen ? <PaymentItemsWrapper productDetailData={productDetailData} selectedItems={[]} /> : null}
      </ModalWrapper>
    </>
  );
};

export default ProductVideoInputWrapper;
